import React from 'react';
import Heading from '@hubins/components/Heading';
import SimpleTable from 'modules/Tables/SimpleTable';
import ShowRawResponse from './ShowRawResponse';
const tableHeaders = [
  {
    Header: '',
    accessor: 'type'
  },
  {
    Header: '',
    accessor: 'value'
  },

]

const CompanyRisksTemplate = ({ screening }) => {
  return (
    <>
      <div className='flex flex-direction-row space-between align-items-center s-bottom-l'>
        <Heading className='s-top-l' size="4">Company id: {screening?.result?.companyId}</Heading>
        <ShowRawResponse screening={screening} />
      </div>
      {(screening?.result?.indicators && Array.isArray(screening.result.indicators)) ? screening.result.indicators.map((hit) => {
        return (
          <div className='s-bottom-l'>
            <SimpleTable
              headers={tableHeaders}
              data={[
                {
                  type: 'Rule name',
                  value: hit?.indicatorName ? hit.indicatorName : 'N/A'
                },
                {
                  type: 'Rule description',
                  value: hit?.ruleDescription ? hit.ruleDescription : 'N/A'
                },
                {
                  type: 'Rule result',
                  value: hit?.indicatorResult ? 'True' : 'False'
                },
                {
                  type: 'Actual value',
                  value: hit?.actualValue ? hit.actualValue : 'N/A'
                },
              ]}
            />
          </div>
        )
      }) : <p>No indicators found</p>}
    </>
  )
};

export default CompanyRisksTemplate;